import type { PlainDate, ZonedDateTime } from "@sa-nu/shared-utils/date";

import { getSameDayMinNight } from "../../_utils/reservation-cutoff";

// リモート拠点は延泊されやすく直前キャンセルの機会損失が大きいため、猶予日数を標準より長く取る
// （遠方施設のキャンセル料発生ルールと同じ 7日/14日 の区分）。
const LEAD_TIME_DAYS_STANDARD = 7;
const LEAD_TIME_DAYS_REMOTE = 14;

/**
 * キャンセル不可オプションで選択可能になる最短初泊日。
 * CI の 7日/14日前 15 時を過ぎたら翌日にずれるので、当日予約と同じ 15 時の締めを起点にする。
 */
export function getLeadTimeBoundaryDate(
  currentTime: ZonedDateTime,
  isRemote: boolean,
): PlainDate {
  return getSameDayMinNight(currentTime).add({
    days: isRemote ? LEAD_TIME_DAYS_REMOTE : LEAD_TIME_DAYS_STANDARD,
  });
}
